module.exports = __webpack_public_path__ + "static/media/marker.13344b92.png";